<template>
  <v-container color="secondary" class="loan-queue" grid-list-xl fluid>
    <v-card flat class="p-10" width="100%" style="height: calc(100vh - 170px)" :loading="tabLoading">
      <vue-perfect-scrollbar style="height: calc(100vh - 200px);">
        <v-card color="secondary" v-for="(item, i) in relatedRequestCode" :key="i" class="m-b-5 m-t-5 m-r-10">
          <v-card-text>
            <v-layout row>
              <v-flex class="lg4"><h4 class="f-w-500">{{item.loanNo}}</h4></v-flex>
              <v-flex class="lg7"><h4 class="f-w-400">{{item.name}}</h4></v-flex>
              <v-btn
                  icon
                  color="primary"
                  @click="goToDetail(item)"
              >
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-layout>
            <v-layout row>
              <v-flex class="lg2 p-0 p-l-10">SSN</v-flex>
              <v-flex class="lg4 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{formatSsn(item.ssn)}}
                    </span>
                  </template>
                  <span>{{formatSsn(item.ssn)}}</span>
                </v-tooltip>
              </v-flex>
              <v-flex class="lg2 p-0">Email</v-flex>
              <v-flex class="lg3 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{item.email}}
                    </span>
                  </template>
                  <span>{{item.email}}</span>
                </v-tooltip>
                </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg2 p-0 p-l-10">Account #</v-flex>
              <v-flex class="lg4 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{item.accountNo}}
                    </span>
                  </template>
                  <span>{{item.accountNo}}</span>
                </v-tooltip>
              </v-flex>
              <v-flex class="lg2 p-0">Routing #</v-flex>
              <v-flex class="lg3 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{formatAccountNo(item.routingNo)}}
                    </span>
                  </template>
                  <span>{{formatAccountNo(item.routingNo)}}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg2 p-0 p-l-10">Home Phone</v-flex>
              <v-flex class="lg4 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                     {{assist.tool.formatPhone(item.homePhone)}}
                    </span>
                  </template>
                  <span>{{assist.tool.formatPhone(item.homePhone)}}</span>
                </v-tooltip>
              </v-flex>
              <v-flex class="lg2 p-0">Cell Phone</v-flex>
              <v-flex class="lg3 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{assist.tool.formatPhone(item.cellPhone)}}
                    </span>
                  </template>
                  <span>{{assist.tool.formatPhone(item.cellPhone)}}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg2 p-0 p-l-10">Create Time</v-flex>
              <v-flex class="lg4 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{new Date(item.createdAt).format("yyyy-MM-dd")}}
                    </span>
                  </template>
                  <span>{{new Date(item.createdAt).format("yyyy-MM-dd")}}</span>
                </v-tooltip>
              </v-flex>
              <v-flex class="lg2 p-0">Request Code</v-flex>
              <v-flex class="lg3 p-0 f-w-500 text-flow">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span  v-bind="attrs" v-on="on">
                      {{ item.requestCode }}
                    </span>
                  </template>
                  <span>{{ item.requestCode }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </vue-perfect-scrollbar>
    </v-card>
    <v-dialog v-model="isShowResponse" width="100%" class="height-style">
      <v-card outlined style="background: #e3f5fe; height: 100vh">
        <v-card-text style="background: #e3f5fe !important; color: #2f428e;">
          <v-row class="m-t-20 m-l-20">
            <h3 class="">Instant Bank Verification Details</h3>
            <v-spacer></v-spacer>
            <v-btn
                text
                class="ma-2 white--text"
                fab
                @click="isShowResponse = false"
            >
              <v-icon dark style="color: #2f428e">
                close_fullscreen
              </v-icon>
            </v-btn>
          </v-row>
          <v-row class="">
            <div class="related" style="padding: 0 20px 0 14px">
              <div class="color-label">Related Loan #: <span class="color-content">{{ relatedLoanData.loanNo }}</span></div>
              <div class="color-label">Request Code : <span class="color-content">{{ relatedLoanData.requestCode }}</span></div>
            </div>
            <div class="related" style="padding:0 32px 0 16px">
              <div class="color-label">Current Loan #: <span class="color-content">{{ currentLoanData.loanNo }}</span></div>
              <div class="color-label">Request Code : <span class="color-content">{{ currentLoanData.requestCode }}</span></div>
            </div>
          </v-row>
        </v-card-text>
        <v-card-text class="table-flex">
          <v-data-table
              class="m-r-line m-b-line"
              v-model="selected"
              :headers="transactionsHeadersV4"
              :items="chirpReportData"
              item-key="index"
              hide-default-footer
              :loading="loading"
              :item-class="bgColor"
              disable-pagination
              fixed-header
              height="86vh"
          >
            <template v-slot:item.transactionDate="{ item }">
              <td style="white-space: nowrap; font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.formatDate(item.transactionDate) }}</td>
            </template>
            <template v-slot:item.status="{ item }">
              <td style="white-space: nowrap; font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.isNotEmpty(item.status) ? item.status.substr(0,1).toUpperCase() + item.status.substr(1) : '' }}</td>
            </template>
            <template v-slot:item.category="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ item.category }}</td>
            </template>
            <template v-slot:item.categoryCode="{ item }">
              <td style="white-space: nowrap; font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ item.categoryCode }}</td>
            </template>
            <template v-slot:item.description="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ item.description }}</td>
            </template>
            <template v-slot:item.amount="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.formatCurrency(item.amount) }}</td>
            </template>
            <template v-slot:item.balance="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.formatCurrency(item.balance) }}</td>
            </template>
          </v-data-table>
          <v-data-table
              class="m-b-line"
              v-model="selected"
              :headers="transactionsHeaders"
              :items="transactionSummary5"
              :loading="loading"
              item-key="index"
              :item-class="bgColor"
              hide-default-footer
              disable-pagination
              fixed-header
              height="86vh"
          >
            <template v-slot:item.transactionDate="{ item }">
              <td style="white-space: nowrap; font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.formatDate(item.transactionDate) }}</td>
            </template>
            <template v-slot:item.status="{ item }">
              <td style="white-space: nowrap; font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.isNotEmpty(item.status) ? item.status.substr(0,1).toUpperCase() + item.status.substr(1) : '' }}</td>
            </template>
            <template v-slot:item.category="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ item.category }}</td>
            </template>
            <template v-slot:item.typeCodes="{ item }">
              <td style="white-space: nowrap; font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ item.typeCodes }}</td>
            </template>
            <template v-slot:item.description="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ item.description }}</td>
            </template>
            <template v-slot:item.amount="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.formatCurrency(item.amount) }}</td>
            </template>
            <template v-slot:item.runningBalance="{ item }">
              <td style="font-size: 12px; font-weight: 300; color: #2f428e" :class="decideStatus(item)">{{ assist.tool.formatCurrency(item.balance) }}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { DataType, Tool } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { OriginationBusinessApi } from '@/api/lms/origination-business'

const tool = new Tool()

export default {
  inject: ['reload'],
  name: 'related-request-code-queue',
  props: {
    relatedRequestCode: Array,
    loan: Object,
    tabLoading: Boolean,
    loanData: Object
  },
  data () {
    return {
      loading: true,
      showInstallmentItems: false,
      tableData: [],
      assist: {
        tool: new Tool()
      },
      selected: [],
      transactionSummary5: [],
      chirpReportData: [],
      transactionsHeaders: LIST_TABLE_HEADER.TRANSACTION_HEADER,
      transactionsHeadersV4: LIST_TABLE_HEADER.TRANSACTION_HEADER_V4,
      isShowResponse: false,
      disabled: false,
      relatedLoanData: {
        loanNo: '',
        requestCode: ''
      },
      currentLoanData: {
        loanNo: '',
        requestCode: ''
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  mounted () {},
  methods: {
    getWithdrawnReasonByCode (code) {
      if (code && DataType.WithdrawnReason[code]) {
        return DataType.WithdrawnReason[code]
      }
    },
    getFullName (data) {
      return {
        fullName: tool.getFullName(data)
      }
    },
    formatSsn (ssn) {
      try {
        ssn = ssn.toString().replace(/[^0-9]/gi, '')
        return '***-**' + '-' + ssn.substring(5, ssn.length)
      } catch (e) {
        return null
      }
    },
    bgColor (item) {
      if (item.flag === 1) {
        return 'yellow'
      } else {
        return 'font-color'
      }
    },
    decideStatus (item) {
      return item.flag === 1 ? 'pending' : ''
    },
    formatAccountNo (accountNo) {
      try {
        accountNo = accountNo.toString().replace(/[^0-9]/gi, '')
        return '*****' + '-' + accountNo.substring(accountNo.length - 4, accountNo.length)
      } catch (e) {
        return null
      }
    },
    goToDetail (item) {
      this.transactionSummary5 = []
      this.chirpReportData = []
      this.isShowResponse = true
      this.loading = true
      let provider = DataType.IBVProviderType.DECISION_LOGIC.value
      const ibvDataObj = {}
      if (tool.isNotEmpty(this.loanData.ibvDataList)) {
        this.loanData.ibvDataList.map(item => {
          if (item.provider === DataType.IBVProviderType.DECISION_LOGIC.value) {
            ibvDataObj.DLData = item
          } else if (item.provider === DataType.IBVProviderType.CHIRP.value) {
            ibvDataObj.chirpData = item
          }

          if (tool.isNotEmpty(ibvDataObj)) {
            if (tool.isEmpty(ibvDataObj.chirpData) && tool.isNotEmpty(ibvDataObj.DLData)) {
              provider = DataType.IBVProviderType.DECISION_LOGIC.value
            } else if (tool.isEmpty(ibvDataObj.DLData) && tool.isNotEmpty(ibvDataObj.chirpData)) {
              provider = DataType.IBVProviderType.CHIRP.value
            } else if (tool.isNotEmpty(ibvDataObj.chirpData) && tool.isNotEmpty(ibvDataObj.DLData)) {
              if (ibvDataObj.DLData.providerStatus === 1) {
                provider = DataType.IBVProviderType.DECISION_LOGIC.value
              } else if (ibvDataObj.chirpData.providerStatus === 1) {
                provider = DataType.IBVProviderType.CHIRP.value
              } else {
                provider = DataType.IBVProviderType.DECISION_LOGIC.value
              }
            }
          } else {
            provider = DataType.IBVProviderType.DECISION_LOGIC.value
          }
        })
      }
      const input = {
        currentLoan: {
          provider: provider,
          loanId: this.loan.loanId
        },
        relatedLoan: {
          portfolioId: item.portfolioId,
          loanId: item.loanId,
          requestId: item.requestId
        }
      }

      const $this = this
      OriginationBusinessApi.getReportsDiff(input, function (result) {
        const ibvData = result.sameAccounts[0]
        if (tool.isNotEmpty(ibvData)) {
          $this.transactionSummary5 = ibvData.currentAccount.transactions
          $this.chirpReportData = ibvData.relatedAccount.transactions
          $this.relatedLoanData.loanNo = ibvData.relatedAccount.accountNumber
          $this.relatedLoanData.requestCode = ibvData.relatedAccount.requestCode
          $this.currentLoanData.loanNo = ibvData.currentAccount.accountNumber
          $this.currentLoanData.requestCode = ibvData.currentAccount.requestCode
          $this.loading = false
        } else {
          $this.disabled = true
        }
      })
    }
  }
}
</script>
<style scoped>
.text-flow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  /*-o-text-overflow: ellipsis;*/
}
.table-flex {
  display: flex;
  font-size: 14px !important;
}
.m-r-line {
  border-right: 1px solid #ccc;
}
.m-b-line {
  height: 86vh;
  width: 50%;
  background: #e3f5fe;
  color: #010101;
}
.pending {
  color: orange !important;
}
/deep/.v-dialog {
  background: #e3f5fe;
  overflow: hidden;
  margin: 0;
}
/deep/.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100vh;
}
.yellow {
  background-color: yellow;
  border-bottom: orange;
}
/deep/.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #e3f5fe;
}
/deep/.v-progress-linear .v-progress-linear__indeterminate .long {
  background-color: #fff !important;
}
/deep/.v-progress-linear .v-progress-linear__indeterminate .short {
  background-color: #fff !important;
}
/deep/.theme--light.v-data-table.v-data-table--fixed-header thead th {
  background-color: #e3f5fe;
}
.height-style {
  height: 100vh;
}
.related {
  width: 50%;
  display: flex;
  justify-content: space-between;
}
.color-label {
  color: #010101;
}
.color-content {
  color: #2f428e;
}
</style>
